import { styled } from "styled-components";

export const ANIMATION_DURATION = 1000;

export const Container = styled.span({
  display: "inline-flex",
  margin: "0px 8px",
});

interface DotProps {
  $animationDelayMs: number;
}

export const Dot = styled.span<DotProps>(({ theme, $animationDelayMs }) => {
  return {
    height: 8,
    width: 8,
    margin: "0 2px",
    borderRadius: theme.radii.round,
    backgroundColor: "#adadb3",
    opacity: 0.2,
    animationDelay: `${$animationDelayMs}ms`,
    animationName: "pulse",
    animationIterationCount: "infinite",
    animationDuration: `${ANIMATION_DURATION}ms`,
  };
});
